import React, {Component} from 'react'
import {connect} from 'react-redux'
import {adminSettingsLoadingStateSelector, adminSettingsDataSelector, handleLoadAdminSettings, handleUpdateAdminSettings, adminSettingsSet} from '../../modules/app'
import PropTypes from 'prop-types'
import { reduxForm, Field } from 'redux-form'
import RenderInputFormGroup from '../common/Form/RenderInputFormGroup'
import {email} from "../common/Form/rules"
import Loader from '../common/Loader'


class Settings extends Component{
    render() {
        let {handleSubmit, error, submitting, submitSucceeded, loading, loaded} = this.props
        let {formatMessage} = this.context

        if (loading && !loaded) return <Loader />

        return (
            <form className="profile-form" onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-xs-12 col-sm-6 col-sm-offset-3">
                        <Field
                            name = "sender-admin-email"
                            type = "text"
                            component = {RenderInputFormGroup}
                            label = {`${formatMessage("senderAdminEmail")}:`}
                            id = "sender-admin-email"
                            validate = {[email]}
                            autoComplete = "off"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-6 col-sm-offset-3">
                        <Field
                            name = "receiver-admin-email"
                            type = "text"
                            component = {RenderInputFormGroup}
                            label = {`${formatMessage("receiverAdminEmail")}:`}
                            id = "receiver-admin-email"
                            validate = {[email]}
                            autoComplete = "off"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-6 col-sm-offset-3">
                        <Field
                            name = "support-email"
                            type = "text"
                            component = {RenderInputFormGroup}
                            label = {`${formatMessage("supportEmail")}:`}
                            id = "support-email"
                            validate = {[email]}
                            autoComplete = "off"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-6 col-sm-offset-3">
                        <Field
                            name = "notify-about-new-user"
                            type = "checkbox"
                            component = {RenderInputFormGroup}
                            label = {`${formatMessage("Norify about new user registration")}:`}
                            id = "notify-about-new-user"
                        />
                    </div>
                </div>

                {
                    submitSucceeded &&
                    <div className="row">
                        <div className="col-xs-12 text-center text-success">{formatMessage("adminSettingsUpdated")}.</div>
                    </div>
                }

                {
                    error &&
                    <div className="row">
                        <div className="col-xs-12 text-center text-danger">{error}</div>
                    </div>
                }

                <div className="btn-fld">
                    <button
                        className="btn btn-primary btn-sm"
                        type="submit"
                        disabled={submitting}
                    >{formatMessage("Save")}</button>
                </div>
            </form>
        )
    }

    componentDidMount() {
        let {handleLoadAdminSettings} = this.props
        handleLoadAdminSettings()
    }

    static contextTypes = {formatMessage: PropTypes.any}
}

export default connect(
    state => {
        let {loading, loaded} = adminSettingsLoadingStateSelector(state)
        let {senderAdminEmail, receiverAdminEmail, supportEmail, notifyAboutNewUser} = adminSettingsDataSelector(state)
        return {
            loading,
            loaded,
            initialValues : {
                "sender-admin-email" : senderAdminEmail,
                "receiver-admin-email" : receiverAdminEmail,
                "support-email" : supportEmail,
                "notify-about-new-user" : notifyAboutNewUser,
            }
        }
    },
    { handleLoadAdminSettings }
)(reduxForm({
    form : 'admin-settings',
    onSubmit : (values, dispatch) => {
        let {"sender-admin-email" : senderAdminEmail, "receiver-admin-email" : receiverAdminEmail, "support-email" : supportEmail, "notify-about-new-user" : notifyAboutNewUser} = values

        return handleUpdateAdminSettings({senderAdminEmail, receiverAdminEmail, supportEmail, notifyAboutNewUser})
                    .then(() => {
                        dispatch(adminSettingsSet({senderAdminEmail, receiverAdminEmail, supportEmail, notifyAboutNewUser}))
                    })
    },
    enableReinitialize : true
})(Settings))


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/Settings.js